<div class="cms-block pos-{{ position }} cms-block-{{ type }}" [ngClass]="{'bg-image': backgroundMedia}">
    <app-cms-snippet-background-image
            [backgroundMedia]="backgroundMedia"></app-cms-snippet-background-image>
    <div class="cms-block-container" style="{{ style }}">
        <div class="cms-block-container-row row cms-row ">
            <div class="col-md-6">
                <div class="cms-element-{{ left.type }}" [innerHTML]="leftContent"></div>
            </div>

            <div class="col-md-6">
                <div class="cms-element-{{ right.type }}" [innerHTML]="rightContent"></div>
            </div>
        </div>
    </div>
</div>